<template>
	<div @click="selectGift()" @mouseover="playAnimation()" @mouseleave="stopAnimation()" :class="['gift', `gift--${type}`, this.$store.state.form.gift === price ? 'gift--selected' : '']">
		<div class="image"><div class="svg" ref="svg"></div></div>
		<strong>${{price}} Gift</strong>
	</div>
</template>

<script>
import lottie from 'lottie-web';

export default {
	props: ['type', 'price'],
	data () {
		return {
			animation: null,
		};
	},
	mounted () {
		this.animation = lottie.loadAnimation({
			container: this.$refs.svg,
			renderer: 'svg',
			loop: true,
			autoplay: false,
			animationData: require(`@/assets/json/${this.type}.json`),
		});
	},
	methods: {
		selectGift () {
			this.$store.commit('formGift', this.price);
		},
		playAnimation () {
			if (window.innerWidth > 720) {
				this.animation.play();
			}
		},
		stopAnimation () {
			if (window.innerWidth > 720) {
				this.animation.stop();
			}
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';
	@import '../assets/less/form.less';

	.gifts-container { padding: 1rem 1rem 0; background-color: #fff; text-align: center; }
	.gifts { display: flex; flex-wrap: wrap; justify-content: space-between; }
	.gift { position: relative; overflow: hidden; display: flex; flex-direction: column; justify-content: flex-end; width: 30%; height: 127px; margin-bottom: 1rem; border: 1px solid @blue; cursor: pointer;
		.image { flex: 1 1 auto; background: white url() 50% 50% no-repeat; }
		strong { display: block; width: 100%; padding: 0.5rem 0; color: white; background-color: @blue; font-size: 13/16rem; .bold(); }

		&--envelope .svg { .top-left(-76%,-67%); .size(220%); }
		&--giftbox .svg { .top-left(-60%,-34%); .size(170%); }
		&--chocolate .svg { .top-left(-40%,-15%); .size(130%); }
		&--bear .svg { .top-left(-47%,-28%); .size(160%); }
		&--flowers .svg { .top-left(-10%,0); .size(100%); }
		&--balloons .svg { .top-left(-12%, 0); .size(100%); }

		&--selected { border-color: @green;
			strong { background-color: @green; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/GiftItem.vue